import BestSellingHandoutContainer from "modules/Discover/containers/BestSellingHandoutContainer/BestSellingHandoutContainer";

type Props = {};

const BestSellingHandout = (props: Props) => {
  return <BestSellingHandoutContainer />;
};

export default BestSellingHandout;
